import NotificationActionsPopup from './NotificationActionsPopup';

export default NotificationActionsPopup;
